import { z } from 'zod';
export const agendaPublicationRuleUnitSchema = z.enum(['business_days', 'days', 'hours']);
export const agendaPublicationRuleCreateSchema = z.object({
    name: z.string().trim().min(1, 'Name is required').max(255),
    unit: agendaPublicationRuleUnitSchema,
    amount: z.number().int().min(1, 'Amount must be at least 1').max(365, 'Amount cannot exceed 365'),
    isActive: z.boolean().optional(),
});
export const agendaPublicationRuleUpdateSchema = agendaPublicationRuleCreateSchema
    .partial()
    .refine((data) => Object.values(data).some((value) => value !== undefined), 'At least one field must be provided');
